import { Locales } from '../types/types';

export type UIErrorI18nKey = 'errorNotFound' | 'errorUnauthorized' | 'insufficientPoints' | 'userIsShop' | 'invalidQrCode' | 'somethingWentWrong' | 'invalidPromoCode' | 'alreadyCancelled' | 'customerLimitExceeded' | 'shopNotFound' | 'noActiveSubscription' | 'invalidSubscriptionPlan';

type TranslationResources = {
  [lang in Locales]: {
    [key in UIErrorI18nKey]: string;
  };
}

export const errorsTranslations : TranslationResources = {
  en: {
    somethingWentWrong: 'Ops, Something went wrong',
    invalidQrCode: 'Invalid Qr code',
    userIsShop: 'Unable to delete this profile from the app because the email is associated with a store, log in to the dashboard to manage your profile',
    insufficientPoints: 'Insufficient points',
    errorNotFound: 'Not Found',
    errorUnauthorized: 'Unauthorized',
    invalidPromoCode: 'Invalid promo code',
    alreadyCancelled: 'Transaction already cancelled',
    customerLimitExceeded: 'Customer limit reached. This shop has reached the maximum number of customers for its subscription plan.',
    shopNotFound: 'Shop not found',
    noActiveSubscription: 'No active subscription',
    invalidSubscriptionPlan: 'Invalid subscription plan'
  },
  it: {
    somethingWentWrong: 'Ops, Qualcosa è andato storto',
    invalidQrCode: 'Qr code non valido',
    userIsShop: 'Impossibile eliminare questo profilo dall\'app perché l\'email è associata ad un negozio, accedi alla dashboard per gestire il tuo profilo',
    insufficientPoints: 'Punti non sufficienti',
    errorNotFound: 'Non trovato',
    errorUnauthorized: 'Non autorizzato',
    invalidPromoCode: 'Codice promozionale non valido',
    alreadyCancelled: 'Transazione già cancellata',
    customerLimitExceeded: 'Limite clienti raggiunto. Questo negozio ha raggiunto il limite massimo di clienti per il suo piano di abbonamento.',
    shopNotFound: 'Negozio non trovato',
    noActiveSubscription: 'Nessun abbonamento attivo',
    invalidSubscriptionPlan: 'Piano di abbonamento non valido'
  }
}
